export default __webpack_public_path__ + "static/media/logo-tokit.f77bc2dd.png";